import { render, staticRenderFns } from "./BulkArchiveFileUploadComponent.vue?vue&type=template&id=0411ed04"
import script from "./BulkArchiveFileUploadComponent.vue?vue&type=script&lang=js"
export * from "./BulkArchiveFileUploadComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports